import { Reveal, Overline } from "./anim";

const STUDIES = [
  {
    tag: "Google · Project Aristotle (2015)",
    body: "A comprehensive two-year study of 180 teams found that psychological safety was the number one predictor of high performance. The ability for people to be vulnerable, ask the ridiculous questions, and be their true selves without fear of judgement was the key.",
  },
  {
    tag: "Wharton · Adam Grant (2020)",
    body: "Found that leaders who actively share feedback about their own negative performance and shortcomings build the strongest psychological safety amongst their teams — much like Ted Lasso.",
  },
];

const STATS = [
  { k: "60%", v: "more likely to build deep trust when leaders display vulnerability with their organisation.", src: "Binghamton University" },
  { k: "25%", v: "increase in employee engagement for teams with vulnerable leaders.", src: "Gallup" },
  { k: "30%", v: "boost in innovation in cultures where it's safe to make mistakes.", src: "Harvard Business Review" },
  { k: "40%", v: "increase in employee resilience — with fewer sick days and lower turnover — in workplaces that encourage connection.", src: "American Psychological Association" },
];

export default function Research() {
  return (
    <section id="research" className="relative bg-ink py-24 md:py-36 border-t border-line-d" data-testid="research-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="mb-16 md:mb-20 max-w-3xl">
          <Overline>The Research</Overline>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl text-sand tracking-tight leading-tight">
            This isn't a feeling. It's backed by the science.
          </h2>
          <p className="mt-6 text-muted-d text-base md:text-lg leading-relaxed">
            Decades of research show the same thing: when people feel safe to be themselves, teams trust more deeply,
            innovate faster and perform at their best.
          </p>
        </Reveal>

        {/* Featured studies */}
        <div className="grid md:grid-cols-2 gap-5 mb-5">
          {STUDIES.map((s, i) => (
            <Reveal key={s.tag} delay={i * 0.08}>
              <div className="h-full border border-line-d bg-ink-soft p-8 md:p-10 hover:border-terra transition-colors duration-500" data-testid={`study-${i}`}>
                <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-terra">{s.tag}</p>
                <p className="mt-5 font-display text-xl md:text-2xl text-sand leading-snug">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Stat grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-line-d">
          {STATS.map((s, i) => (
            <Reveal key={s.src} delay={i * 0.06}>
              <div className="h-full border-b border-r border-line-d p-8 flex flex-col" data-testid={`research-stat-${i}`}>
                <div className="font-display text-5xl md:text-6xl text-terra leading-none">{s.k}</div>
                <p className="mt-5 text-muted-d text-sm leading-relaxed flex-1">{s.v}</p>
                <p className="mt-5 font-mono text-[10px] tracking-[0.15em] uppercase text-sand">{s.src}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
